module.exports = __webpack_public_path__ + "static/media/refresh-p.7e370084.svg";